import type { FieldPath } from 'react-hook-form';
import { z } from 'zod';
import { ProgramOccurrence } from '@/apolloClient.types';

export const programFormSchema = z.object({
    name: z.string().min(1, { message: 'Required' }),
    description: z.string().optional(),
    courseInstanceId: z.string().min(1, { message: 'Required' }),
    occurrence: z.nativeEnum(ProgramOccurrence, { errorMap: () => ({ message: 'Occurrence is required' }) }),
});

export type ProgramFormData = z.infer<typeof programFormSchema>;

export const defaultProgramFormValues: ProgramFormData = {
    name: '',
    description: '',
    courseInstanceId: '',
    occurrence: ProgramOccurrence.NotRepeating,
};

export const getFieldsToValidate = (): FieldPath<ProgramFormData>[] => {
    return ['name', 'courseInstanceId', 'occurrence'];
};
